import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-logged-out',
  imports: [RouterLink],
  templateUrl: './logged-out.html',
  styleUrl: './logged-out.css',
})
export class LoggedOutComponent {

}
